import React, { useState, Fragment, useEffect } from "react";
import styles from "./CciApps.module.css";
import {
  Row,
  Col,
  Card,
  Tooltip,
  Space,
  Spin,
  Button,
  Input,
  Table,
  Select,
  message,
  Tag,
} from "antd";
import { CloudDownloadOutlined, SearchOutlined } from "@ant-design/icons";
import { fetchTrend, fetchJsData } from "../../../../api";
import { crawl } from "../../../../api/util";
import { OpenModal } from "./AppModal";
import { CSVLink } from "react-csv";
const { Option } = Select;

const fetchUserSearch = async (rel, prior) => {
  const data = await fetchJsData({
    type: "fetch",
    qry: "fetCciApps",
    firstVal: rel,
    secondVal: rel,
    thirdVal: rel,
    fourthVal: rel,
    fifthVal: rel,
    sixthVal: "%" + prior + "%",
  });
  return data;
};

const CciApps = () => {
  const [rel, setRel] = useState(null);
  const [usrRel, setUsrRel] = useState("");
  const [diff, setDiff] = useState(0);
  const [load, setLoad] = useState(true);
  const [submit, setSubmit] = useState(true);
  const [value, setValue] = useState({
    event: false,
    radioValue: "",
  });

  const [renderer, updateRender] = useState("tab1");
  const onTabChng = (key) => {
    updateRender(key);
    setSubmit(!submit);
  };

  useEffect(() => {
    if (!rel) {
      fetchData();
    }
  }, [rel]);

  const fetchData = async () => {
    setLoad(true);
    const relVersion = await fetchTrend("fetConVersion");
    // setRel("snapshot_" + relVersion["version"]);
    setRel(relVersion["curVersion"]);
    setUsrRel("snapshot_v" + relVersion["curVersion"] + "_0_0");
    setLoad(false);
  };

  const contentList = {
    tab1: (
      <FetchTabSearch
        submit={submit}
        rel={rel}
        usrRel={usrRel}
        prior="custom_p1"
        type="own"
      />
    ),
    tab2: (
      <FetchTabSearch
        submit={submit}
        rel={rel}
        usrRel={usrRel}
        prior="custom_p2"
        type="own"
      />
    ),
  };

  function onChange(value) {
    message.info(`Release snapshot_v${value}_0_0`);
    setUsrRel("snapshot_v" + value + "_0_0");
    setDiff(rel - value);
    setSubmit(!submit);
  }

  const onBtnClick = (reqType) => {
    setValue({ event: true, radioValue: reqType });
  };

  return (
    <div>
      {/* Release */}
      <Row type="flex" style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col className="gutter-row" span={14}>
          <Card
            bordered={false}
            style={{ height: 70, margin: "1px", padding: "1px" }}
          >
            <Space>
              {load ? (
                <div>
                  <Spin size="small" />
                </div>
              ) : (
                <Select
                  defaultValue={rel}
                  showSearch
                  style={{ width: 400 }}
                  placeholder="Select Release"
                  optionFilterProp="children"
                  onChange={onChange}
                >
                  <Option value={rel}>Release {rel}</Option>
                  <Option value={rel - 1}>Release {rel - 1}</Option>
                  <Option value={rel - 2}>Release {rel - 2}</Option>
                  <Option value={rel - 3}>Release {rel - 3}</Option>
                  <Option value={rel - 4}>Release {rel - 4}</Option>
                </Select>
              )}
            </Space>
          </Card>
        </Col>
      </Row>

      {/* Card */}
      <Row style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col className="gutter-row" span={22}>
          {load ? (
            <div className={styles.spinner}>
              <Spin size="small" />
            </div>
          ) : (
            <>
              <Card
                style={{ width: "100%" }}
                // title="Card title"
                extra={
                  diff <= 1 ? (
                    <Space>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          onBtnClick("new");
                        }}
                      >
                        New CCI Apps
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          onBtnClick("changed");
                        }}
                      >
                        Changed CCL Apps
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          onBtnClick("newdomain");
                        }}
                      >
                        New Domains
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          onBtnClick("updatedCat");
                        }}
                      >
                        Apps with Updated Category
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          onBtnClick("appNameChnged");
                        }}
                      >
                        Name Changed Apps
                      </Button>
                    </Space>
                  ) : (
                    <></>
                  )
                }
                tabList={tabList}
                // activeTabKey={tabList[0]["key"]}
                onTabChange={onTabChng}
              >
                {contentList[renderer]}
              </Card>
              <Fragment>
                <OpenModal
                  openModal={value["event"]}
                  usrSel={value["radioValue"]}
                  rel={rel}
                  usrRel={usrRel}
                  setValue={setValue}
                />
              </Fragment>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

const FetchTabSearch = (props) => {
  const [searchVal, setSearchVal] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [searchIndex, setSearchIndex] = useState([]);
  const [loading, setLoading] = useState(true);

  const ColOwn = [
    {
      title: () => {
        return (
          <>
            Application name{" "}
            {loading ? (
              <div>
                <Spin size="small" />
              </div>
            ) : (
              <Tag color="processing">{filteredData.length}</Tag>
            )}
          </>
        );
      },
      dataIndex: "current_name",
      key: "current_name",
      fixed: "left",
      width: "30%",
      sorter: (a, b) =>
        a.current_name ? a.current_name.localeCompare(b.current_name) : 1,
      render: (text, record) => (
        <Space size="middle">
          <span>{record.current_name}</span>
        </Space>
      ),
    },
    {
      title: "Category",
      dataIndex: "category_name",
      key: "category_name",
      defaultSortOrder: "ascend",
      sorter: (a, b) =>
        a.category_name ? a.category_name.localeCompare(b.category_name) : 1,
      fixed: "left",
      width: "30%",
    },
    {
      title: "CCI",
      dataIndex: "cci",
      key: "cci",
      fixed: "left",
      sorter: (a, b) => a.cci - b.cci,
      width: "10%",
    },
    {
      title: "CCL",
      dataIndex: "ccl",
      key: "ccl",
      sorter: (a, b) => (a.ccl ? a.ccl.localeCompare(b.ccl) : 1),
      fixed: "left",
      width: "10%",
    },
    {
      title: "Last Verified",
      dataIndex: "refreshedDate",
      key: "refreshedDate",
      fixed: "left",
      width: "10%",
      sorter: (a, b) => new Date(a.refreshedDate) - new Date(b.refreshedDate),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const { data: users } = await fetchUserSearch(props.usrRel, props.prior);
      setOrigData(users);
      setFilteredData(users);
      const searchInd = users.map((user) => {
        const allValues = crawl(user);
        return { allValues: allValues.toString() };
      });
      setSearchIndex(searchInd);
      if (users) setLoading(false);
    };
    fetchData();
  }, [props.submit]);

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex.map((user, index) => {
        if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[index];
        return null;
      });
      setFilteredData(
        reqData.filter((user) => {
          if (user) return true;
          return false;
        })
      );
    } else setFilteredData(origData);
  }, [searchVal, origData, searchIndex, props.submit]);

  return (
    <>
      <div>
        <Row gutter={16}>
          <Col span={24}>
            <Card
              title={
                "Release - " + props.usrRel.split("snapshot_v")[1].split("_")[0]
              }
              size="small"
              headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
              extra={
                <Row>
                  <Col span={21}>
                    <Input
                      onChange={(e) => setSearchVal(e.target.value)}
                      prefix={
                        <SearchOutlined className="site-form-item-icon" />
                      }
                      placeholder="Crawl Search"
                      allowClear
                    />
                  </Col>
                  <Col span={1}></Col>
                  <Col className="gutter-row" span={2}>
                    {" "}
                    <div>
                      {loading ? (
                        <div>
                          <Spin size="small" />
                        </div>
                      ) : (
                        <Tooltip
                          placement="topRight"
                          title="Download Cci App Report"
                          arrowPointAtCenter
                        >
                          <CSVLink
                            filename={"Cci App Report.csv"}
                            data={filteredData}
                            className="btn btn-primary"
                          >
                            <CloudDownloadOutlined
                              style={{ fontSize: "29px" }}
                            />
                          </CSVLink>
                        </Tooltip>
                      )}
                    </div>
                  </Col>
                </Row>
              }
            >
              <Fragment>
                <Table
                  rowKey="application_id"
                  size="small"
                  bordered
                  scroll={{ x: 550, y: 900 }}
                  style={{ margin: "2px" }}
                  dataSource={filteredData}
                  columns={ColOwn}
                  loading={loading}
                  pagination={{
                    pageSizeOptions: ["10", "30", "60", "100", "1000"],
                    defaultPageSize: ["50"],
                    showSizeChanger: true,
                  }}
                />
              </Fragment>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

const tabList = [
  {
    key: "tab1",
    tab: "P1 Apps",
  },
  {
    key: "tab2",
    tab: "P2 Apps",
  },
];

export default CciApps;
